import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon18: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M.127 11.134a7.5 7.5 0 0 1 8.74-6.008.5.5 0 0 1-.182.983 6.499 6.499 0 0 0-7.574 5.207 6.5 6.5 0 1 0 12.78 2.367 6.468 6.468 0 0 0-.003-2.362.5.5 0 0 1 .984-.181c.166.905.17 1.822.004 2.725a7.5 7.5 0 1 1-14.75-2.73ZM7.5 7a.5.5 0 0 1 .5.5v.926a5.58 5.58 0 0 1 1.164.322c.357.14.632.28.795.379a.5.5 0 1 1-.517.855A4.44 4.44 0 0 0 8.8 9.68c-.492-.192-.993-.306-1.464-.306-.986 0-1.68.476-1.68 1.1 0 .688.529 1.075 2.123 1.706l.152.06c1.9.752 2.603 1.25 2.603 2.416 0 1.292-.988 2.06-2.533 2.199l-.001.9a.5.5 0 1 1-1 0L7 16.859a4.504 4.504 0 0 1-1.606-.415c-.356-.172-.595-.351-.727-.488a.5.5 0 0 1 .719-.694c.054.055.199.164.442.28.43.209.976.336 1.646.336 1.359 0 2.06-.455 2.06-1.222 0-.557-.476-.895-1.97-1.486l-.152-.06c-1.984-.786-2.754-1.35-2.754-2.635 0-1.176 1.025-1.971 2.343-2.087V7.5a.5.5 0 0 1 .5-.5Zm8-7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 1a3.5 3.5 0 1 0 .001 7.001A3.5 3.5 0 0 0 15.501 1Zm0 1a.5.5 0 0 1 .5.5V4h1.5a.5.5 0 0 1 .492.41L18 4.5a.5.5 0 0 1-.5.5H16v1.5a.5.5 0 0 1-.41.492L15.5 7a.5.5 0 0 1-.5-.5V5h-1.5a.501.501 0 0 1-.492-.41L13 4.5a.5.5 0 0 1 .5-.5H15V2.5a.5.5 0 0 1 .41-.492l.09-.008Z"
      />
    </Svg>
  )
}
